<a class="flex items-center" [routerLink]="initialRoute">
  <svg
    class="logo__svg fill-base-100 t:w-[164px] mr-[10px] h-[16px] w-[120px] shrink-0"
  >
    <use xlink:href="#vendor-logo"></use>
  </svg>

  <svg class="logo__svg fill-base-100 t:w-[164px] h-[16px] w-[120px]">
    <use xlink:href="#rmm-beta-logo"></use>
  </svg>
</a>
